import { useRef, useCallback, useEffect } from 'react'
import { useRefreshUser } from '../user/redux/refreshUser'

export const usePaymentPolling = (deviceActions, onComplete) => {
  const intRef = useRef(null)
  const { refreshUser } = useRefreshUser()

  const startPolling = useCallback(() => {
    if (intRef.current && intRef.current.int) {
      clearInterval(intRef.current.int)
    }

    intRef.current = {
      int: setInterval(() => {
        // Guard against race condition if stopped during callback
        if (!intRef.current) return

        intRef.current.count++
        refreshUser()

        // Guard against intRef being nullified during refreshUser
        if (!intRef.current) return

        if (intRef.current.count >= 20) {
          clearInterval(intRef.current.int)
          intRef.current = null
          if (onComplete) onComplete()
        }
      }, 1500),
      count: 0
    }
  }, [refreshUser, onComplete])

  const stopPolling = useCallback((setPaymentComplete = false) => {
    if (intRef.current && intRef.current.int) {
      clearInterval(intRef.current.int)
      intRef.current = null
      if (setPaymentComplete) {
        deviceActions.setThing('paymentComplete', true)
      }
      if (onComplete) onComplete()
    }
  }, [deviceActions, onComplete])

  const isPolling = useCallback(() => {
    return intRef.current && intRef.current.int != null
  }, [])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (intRef.current && intRef.current.int) {
        clearInterval(intRef.current.int)
      }
    }
  }, [])

  return { startPolling, stopPolling, isPolling }
}